import type { CatalogConditionItem } from "./types";

/**
 * Whether a catalog condition may be offered for the selected trigger event.
 *
 * Fail-open: when neither the event nor the condition carries applicability
 * metadata (older backends), the condition is treated as applicable so PAM
 * keeps working. Generic user-data conditions (`applicable_event_keys: null`)
 * are always shown. Event-shape-dependent conditions are shown only when the
 * selected event declares support.
 */
export const isConditionApplicableToEvent = (
  item: CatalogConditionItem,
  eventKey: string | undefined,
  eventApplicableTypes?: string[],
): boolean => {
  const keys = item.applicable_event_keys;
  // `null` = universally applicable; `undefined` = older catalog, fail open.
  // Both must win over the per-event allowlist so a partially annotated
  // backend cannot silently drop authorable types.
  if (keys === null || keys === undefined) {
    return true;
  }
  if (eventApplicableTypes && eventApplicableTypes.length > 0) {
    return eventApplicableTypes.includes(item.type_key);
  }
  if (!eventKey) {
    return false;
  }
  return keys.includes(eventKey);
};
